import { render, staticRenderFns } from "./NomeFantasiaField.vue?vue&type=template&id=2bb04746&scoped=true&"
import script from "./NomeFantasiaField.vue?vue&type=script&lang=js&"
export * from "./NomeFantasiaField.vue?vue&type=script&lang=js&"
import style0 from "./NomeFantasiaField.vue?vue&type=style&index=0&id=2bb04746&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb04746",
  null
  
)

export default component.exports